/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeADownLeftIcon16Light } from './ArrowShapeADownLeftIcon16Light';
import { ArrowShapeADownLeftIcon16Regular } from './ArrowShapeADownLeftIcon16Regular';
import { ArrowShapeADownLeftIcon16Solid } from './ArrowShapeADownLeftIcon16Solid';
import { ArrowShapeADownLeftIcon20Light } from './ArrowShapeADownLeftIcon20Light';
import { ArrowShapeADownLeftIcon20Regular } from './ArrowShapeADownLeftIcon20Regular';
import { ArrowShapeADownLeftIcon20Solid } from './ArrowShapeADownLeftIcon20Solid';
import { ArrowShapeADownLeftIcon24Regular } from './ArrowShapeADownLeftIcon24Regular';
import { ArrowShapeADownLeftIcon24Solid } from './ArrowShapeADownLeftIcon24Solid';
import { ArrowShapeADownLeftIcon32Regular } from './ArrowShapeADownLeftIcon32Regular';
import { ArrowShapeADownLeftIcon64Regular } from './ArrowShapeADownLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeADownLeftIcon16Light,
        regular: ArrowShapeADownLeftIcon16Regular,
        solid: ArrowShapeADownLeftIcon16Solid,
    },
    20: {
        light: ArrowShapeADownLeftIcon20Light,
        regular: ArrowShapeADownLeftIcon20Regular,
        solid: ArrowShapeADownLeftIcon20Solid,
    },
    24: {
        regular: ArrowShapeADownLeftIcon24Regular,
        solid: ArrowShapeADownLeftIcon24Solid,
    },
    32: {
        regular: ArrowShapeADownLeftIcon32Regular,
    },
    64: {
        regular: ArrowShapeADownLeftIcon64Regular,
    },
};
export var ArrowShapeADownLeftIcon = forwardRef('ArrowShapeADownLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
